import { useCallback, useMemo } from "react"
import { useTranslation } from "react-i18next"

import { useUserSettings } from "@/contexts"
import type { SelectableLanguageCode } from "@/models/i18n"
import { resolveUnitName, translateUnit } from "@/utils/unit"

export type FormatUnit = (unit: string | null | undefined) => string

export const useFormatUnit = (): { formatUnit: FormatUnit } => {
  const { i18n } = useTranslation()
  const { currency, unitsSystem } = useUserSettings()

  const formatUnit = useCallback(
    (unit: string | null | undefined): string => {
      const translated = translateUnit({
        currencyCode: currency,
        localeCode: i18n.language as SelectableLanguageCode,
        unit: resolveUnitName(unit),
        unitsSystem,
      })

      if (translated !== "") {
        return translated
      }

      return unit?.trim() ?? ""
    },
    [currency, i18n.language, unitsSystem]
  )

  return useMemo(() => ({ formatUnit }), [formatUnit])
}
